import { modalRenderer } from '~/modal/modalRendererRegistry';
import { MapMigrationClientStatusModalContainer } from './mapMigrationClientStatusModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MigrationClientStatus: undefined;
  }
}

modalRenderer.register('MigrationClientStatus', MapMigrationClientStatusModalContainer);
